export default {
  AudioButton: {
    play: 'Play',
  },
  ezinterview_video_help: {
    section1: [
      'Browser detection failed.',
      'chrome 60 or above is required for the video interview. Please download the browser according to the relevant version:',
      'window version download',
      'Download for mac',
      'linux version download',
      'Download ios version',
      'android version download',
      'No other browsers are currently supported.',
    ],
    section2: [
      '2. Camera detection failed.',
      '(1) Make sure that the device has a camera or an external camera device and that drivers are installed.',
      '(2) Please turn off computer anti-virus software, proxy VPN, etc. to ensure that the network speed is above 100kb/s.',
      '(3) Allow the browser to enable camera permissions (click Allow).',
      '(4) Check whether the camera and microphone Settings are disabled on the right side of the browser address bar.',
      '(5) In the security Settings, please set the webcam, microphone and sound permissions to allow.',
    ],
    section3: [
      '3. Microphone detection failed.',
      '(1) Please ensure that the device has a microphone or an external microphone device and that the driver is installed. The device is not turned to silent mode.',
      '(2) Please turn off computer anti-virus software, proxy VPN, etc. to ensure that the network speed is above 100kb/s.',
      '(3) Allow the browser to enable microphone permissions (please click Allow).',
      '(4) Check whether the camera and microphone Settings are disabled on the right side of the browser address bar.',
      '(5) In the security Settings, please set the webcam, microphone and sound permissions to allow.',
    ],
    section4: [
      '4. Sound detection failed.',
      '(1) Please ensure that the computer is equipped with speakers or headphones, and the relevant drivers are installed, and the device is not turned to silent mode.',
      '(2) Please turn off computer anti-virus software, proxy VPN, etc. to ensure that the network speed is above 100kb/s.',
      '(3) Allow the browser to enable camera, microphone permissions (click Allow).',
      '(4) Check whether the camera and microphone Settings are disabled on the right side of the browser address bar.',
      '(5) In the security Settings, please set the webcam, microphone and sound permissions to allow.',
    ],
    tips: 'Go to the app store and search for the latest version of chrome browser to download',
  },
  grading_level: {
    title: 'Rating criteria',
  },
  history_score: {
    absent: 'The candidate is absent and has no result',
    fraud: 'Candidate fraud, no result',
  },
  interviewer_navbar: {
    time: 'Beijing time',
  },
  loginout_btn: {
    logout: 'Log out',
    signOutCofirm: 'Sure to opt out of the interview scoring system?',
    signOutCancel: 'signout cancel',
  },
  navbar: {
    placeholder: 'name',
  },
  operate_and_time: {
    time: 'Beijing Time',
  },
  operate_mobile: {
    title: 'Device detection',
  },
  pre_detection: {
    title: 'Device Detection',
    browser: 'Browser',
    help: 'Help?',
    video: 'Camera',
    audio: 'Microphone',
    broadWidth: 'Video Bandwidth',
    delay: 'Latency',
    confirm: 'Confirm',
    helpTitle: 'Easy Interview Help',
    close: 'close',
    btnName1: ['Detect microphone', 'Stop recording...'],
    btnName2: ['Play sound', 'Stop playing'],
    audioDevice: 'Microphone device',
    videoDevice: 'camera device',
    audioMsg: 'Please stop playing',
    audioConfirmMsg:
      'During microphone detection, the system will record a segment of your voice, and you can click the Play sound button to determine if the microphone is valid.',
    recordMsg1: 'Please click to detect microphone first',
    recordMsg2: 'Please stop recording first',
    errorTips: 'Please try to open this page through a browser to access the camera device',
  },
  table: {
    name: 'Name',
    number: 'Number',
    gender: 'Gender',
    status: 'Status',
    score: 'My Rating',
    average: 'Average',
    class: 'Class',
    checkIn: 'Checked in',
    signIn: 'Signin',
    preview: 'Preview',
    noMsg: 'No candidates yet',
    actions: 'Actions',
    aboveAverage: 'Above average',
    belowAverage: 'Below average',
    statusText: {
      unsubmitted: 'In progress',
      waiting: 'Not started',
      interviewing: 'In progress',
      complete: 'Completed',
      processing: 'Finished',
      confirmed: 'Finished',
      unconfirmed: 'Unconfirmed',
    },
    button: {
      unsubmitted: 'Adjust',
      waiting: 'Scoring',
      interviewing: 'Scoring',
      complete: 'Adjust',
      processing: 'View',
      confirmed: 'Adjust',
      unconfirmed: 'Adjust',
      view: 'View',
    },
    genderOption: {
      男: 'Male',
      女: 'Famale',
    },
    scoreTag: {
      unconfirmed: 'Rejected',
      confirmed: 'Approved',
      processing: 'Pending',
    },
  },
  video_interview: {
    tipMsg: 'Connect, please wait...',
    failMsg: 'Connection failed, please check camera and audio devices',
    retry: 'Click to try again',
    timeMsg: 'Video will end in minutes',
    videoMsg: 'Your video interview window is opened on another device or TAB',
    detectionMsg: 'Please try to open this page through a browser to access the camera device',
  },
  video_table: {
    scoreStatus: 'Class standard',
    arrangement: 'Schedule Name',
    time: 'Interview Time',
    name: 'Name',
    gender: 'Gender',
    score: 'Score',
    average: 'Average',
    class: 'Class',
    login: 'Logged in',
    online: 'online',
    offline: 'offline',
    view: 'View',
    noMsg: 'No candidates yet',
    status: {
      waiting: 'Not started',
      interviewing: 'In progress',
      complete: 'Complete',
      default: 'An error occurred',
    },
    genderOption: {
      男: 'Male',
      女: 'Famale',
    },
  },
  IframePopup: {
    title: "Candidate's test paper",
  },
  fontSize: {
    label: 'Font Size',
    size: {
      normal: 'Normal',
      large: 'Large',
      xlarge: 'Extra Large',
    },
  },
  FileViewer: {
    unknownFile: 'Unknown File',
    downloadFile: 'Download File',
    fileType: {
      doc: 'Word Document',
      xls: 'Excel Spreadsheet',
      ppt: 'PowerPoint Presentation',
      zip: 'Compressed File',
      audio: 'Audio File',
      video: 'Video File',
      fallback: '{ext} File',
    },
  },
};
